import { Box, Typography } from '@mui/material';
import SalesList from './SalesList';

const SalesListPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
      >
      <Box display="flex" flexDirection="column" gap={1} mt={2}>
        <Typography color="primary" variant="h5">
          <b>Minhas vendas</b>
        </Typography>
        <SalesList/>

      </Box>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default SalesListPanel